// Keeps the header cart count / cart drawer in sync when a cart item is
// added by something outside this theme's own Liquid Ajax Cart pipeline
// (assets/m-cart.js) - e.g. the "Move to cart" button on the HulkApps
// Wishlist app's /apps/advanced-wishlist page. That button posts to
// Shopify's /cart/add.js endpoint directly instead of going through
// window.liquidAjaxCart.add(), so the theme's cached cart state never
// learns anything changed and the header count / drawer stay stale until
// a full page reload.
//
// This listens for ANY request to /cart/add(.js) - fetch() or XHR, since
// older/jQuery-based app bundles often use XHR - that did NOT originate
// from our own Liquid Ajax Cart pipeline, and triggers a
// window.liquidAjaxCart.update({}, {}) afterwards. That's the same no-op
// "resync cart state from the server" call this theme already uses for
// window-focus/pageshow refreshes (see c-cart.js / m-cart.js), so it's a
// known-safe way to force the header count and drawer sections to
// re-render without touching the actual cart contents.

(function () {
    var CART_ADD_PATTERN = /\/cart\/add(\.js)?(\?|$)/;

    function isFromOurOwnPipeline() {
        // window.liquidAjaxCart.add()/change()/update()/clear() flip this
        // flag on before their own network request fires - skip those so
        // we don't double-refresh on the theme's own add-to-cart forms.
        return !!(window.liquidAjaxCart && window.liquidAjaxCart.processing);
    }

    function syncThemeCart() {
        // Small delay so the wishlist app's own success handling (closing
        // its own popups/toasts) isn't interrupted mid-flight.
        setTimeout(function () {
            if (window.liquidAjaxCart && typeof window.liquidAjaxCart.update === 'function') {
                window.liquidAjaxCart.update({}, {});
            }
        }, 150);
    }

    // --- fetch() ---
    if (window.fetch) {
        var originalFetch = window.fetch;
        window.fetch = function (input, init) {
            var url = typeof input === 'string' ? input : (input && input.url);
            var isCartAdd = url && CART_ADD_PATTERN.test(url);
            var external = isCartAdd && !isFromOurOwnPipeline();

            return originalFetch.apply(this, arguments).then(function (response) {
                if (external && response.ok) syncThemeCart();
                return response;
            });
        };
    }

    // --- XMLHttpRequest (older/jQuery-based app bundles) ---
    if (window.XMLHttpRequest) {
        var originalOpen = XMLHttpRequest.prototype.open;
        var originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url) {
            this.__isCartAdd = typeof url === 'string' && CART_ADD_PATTERN.test(url);
            return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function () {
            if (this.__isCartAdd && !isFromOurOwnPipeline()) {
                this.addEventListener('loadend', function () {
                    if (this.status >= 200 && this.status < 300) syncThemeCart();
                });
            }
            return originalSend.apply(this, arguments);
        };
    }
})();
